import { z } from 'zod';

/**
 * zod 4 при создании схем пробует `new Function('')`, чтобы решить, можно ли ускоряться через eval.
 * Под нашей CSP (`script-src 'self'`, без 'unsafe-eval') браузер записывает это как нарушение CSP
 * (SEC-6). Режим jitless отключает пробу; потеря скорости на наших объёмах незаметна.
 * Все схемы в shared и в клиенте импортируют z только отсюда (правило линтера).
 */
z.config({ jitless: true });

export { z };
